import React, {
    useMemo,
    useState,
    useCallback,
    useRef,
    useEffect,  // Add useEffec
} from "react";
import {
    Button,
    OverlayTrigger,
    Tooltip,
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";
import { CreatedDateRenderer } from "./K1HelperFunctions";

export const MyKonesGrid = (mykones_grid_props) => {
    // Setting default grid params
    const gridRef = useRef();
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
    const onFirstDataRendered = useCallback((params) => {
        gridRef.current.api.sizeColumnsToFit();
    }, []);

    const onSelectionChanged = useCallback((event) => {
        const rows = event.api.getSelectedRows();
        mykones_grid_props.setselectedrows(rows)
    }, []);

    const defaultColDef = useMemo(
        () => ({
            filter: true,
            resizable: true,
            animateRows: true,
        }),
        []
    );

    // Use useEffect to trigger grid overlay refresh when gridMessage or rowData changes
    useEffect(() => {
        if (gridRef.current && gridRef.current.api) {
            if (mykones_grid_props.rowData && mykones_grid_props.rowData.length === 0) {
                gridRef.current.api.showNoRowsOverlay();
            } else {
                gridRef.current.api.hideOverlay();
            }
        }
    }, [mykones_grid_props.gridMessage, mykones_grid_props.rowData]);

    const CompareKoneRenderer = (compare_kone_props) => {
        // console.log("COMPARE KONE PROPS: ", compare_kone_props)

        return (
            <div style={{
                cursor: compare_kone_props.data.ActiveKone.OCRProgress === "Completed" ? "pointer" : "not-allowed",
            }}>
                {
                    (() => {
                        const status = compare_kone_props.data.Status;
                        switch (true) {
                            case status === "Unverified":
                                return (
                                    <>
                                        <Icon.ExclamationCircleFill style={{ color: "#ffb400" }} />
                                        &nbsp;&nbsp;{status}
                                    </>
                                );
                            case status.toLowerCase() == "unprocessed":
                                return (
                                    <>
                                        <Icon.Hammer style={{ color: "#FFA879" }} />
                                        &nbsp;&nbsp;Processing
                                    </>
                                );
                            case status.toLowerCase().includes("error"):
                                return (
                                    <>
                                        <Icon.XCircleFill style={{ color: "#b51c2c" }} />
                                        &nbsp;&nbsp;{status}
                                    </>
                                );
                            default:
                                return (
                                    <>
                                        <Icon.CheckCircleFill style={{ color: "#008c41" }} />
                                        &nbsp;&nbsp;{status}
                                    </>
                                );
                        }
                    })()
                }
            </div>
        )
    }

    const ActionKoneRenderer = (action_kone_props) => {
        const k1FileId = action_kone_props.data.ApiData[action_kone_props.rowIndex]["K1FileId"];
    
        const compareKone = () => {
            mykones_grid_props.setcomparisondata({
                "file": action_kone_props.data.K1File,
                "activekone": action_kone_props.data.ActiveKone,
                "apidata": action_kone_props.data.ApiData
            });
            mykones_grid_props.setcomparefullwindowmodal(true);
        };
    
        const compareSummary = () => {
            mykones_grid_props.setsummarycomparisondata({
                "file": action_kone_props.data.K1File,
                "activekone": action_kone_props.data.ActiveKone,
                "apidata": action_kone_props.data.ApiData
            });
            mykones_grid_props.setsummarycomparefullwindowmodal(true);
        };
    
        const viewChangeHistory = () => {
            // Navigate to the K1 Change History page or trigger corresponding action
            mykones_grid_props.setk1changehistorydata({
                "K1FileId": k1FileId,
                "FileName": action_kone_props.data.K1Name
            });
            mykones_grid_props.setk1changehistorymodal(true);
            console.log(k1FileId)
        };
    
        return (
            <div className="flex-row-center-center">
                <div style={{
                    cursor: action_kone_props.data.ActiveKone.OCRProgress?.toLowerCase().includes("completed") 
                    ? "pointer" 
                    : "not-allowed",
                }}>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 0, hide: 100 }}
                        overlay={
                            <Tooltip id="button-tooltip">
                                Edit K1 to compare
                            </Tooltip>
                        }
                        error={true}
                    >
                        <Button onClick={() => compareKone()}
                            style={{
                                cursor: "pointer",
                                backgroundColor: "transparent",
                                color: action_kone_props.data.ActiveKone.OCRProgress?.toLowerCase().includes("completed") 
                                    ? "var(--theme1_primary)" 
                                    : "lightgrey",
                                border: "0px solid white",
                                pointerEvents: action_kone_props.data.ActiveKone.OCRProgress?.toLowerCase().includes("completed") 
                                    ? "all" 
                                    : "none"
                            }}>
                            <Icon.BookHalf
                                style={{
                                    fontSize: 15,
                                    color: action_kone_props.data.ActiveKone.OCRProgress?.toLowerCase().includes("completed")
                                        ? "var(--theme1_primary)"
                                        : "lightgrey"
                                }}
                            />
                        </Button>
                    </OverlayTrigger>
                </div>
                <div style={{
                    cursor: "pointer",
                }}>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 0, hide: 100 }}
                        overlay={
                            <Tooltip id="button-tooltip">
                                View K1 Change History
                            </Tooltip>
                        }
                        error={true}
                    >
                        <Button onClick={() => viewChangeHistory()}
                            style={{
                                cursor: "pointer",
                                backgroundColor: "transparent",
                                color: "var(--theme1_primary)",
                                border: "0px solid white",
                            }}>
                            <Icon.ClockHistory style={{ fontSize: 15, color: "var(--theme1_primary)" }} />
                        </Button>
                    </OverlayTrigger>
                </div>
                <div style={{
                    cursor: action_kone_props.data.ActiveKone.Status === "SentToTax (Processing)" ? "pointer" : "not-allowed",
                }}>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 0, hide: 100 }}
                        overlay={
                            <Tooltip id="button-tooltip">
                                Compare K1 summary and edit
                            </Tooltip>
                        }
                        error={true}
                    >
                        <Button onClick={() => compareSummary()}
                            style={{
                                cursor: "pointer",
                                backgroundColor: "transparent",
                                color: action_kone_props.data.ActiveKone.Status === "SentToTax (Processing)" ? "var(--theme1_primary)" : "lightgrey",
                                border: "0px solid white",
                                pointerEvents: action_kone_props.data.ActiveKone.Status === "SentToTax (Processing)" ? "all" : "none"
                            }}>
                            <Icon.Intersect style={{ fontSize: 15, color: action_kone_props.data.ActiveKone.Status === "SentToTax (Processing)" ? "var(--theme1_primary)" : "lightgrey" }} />
                        </Button>
                    </OverlayTrigger>
                </div>
                <div style={{
                    cursor: action_kone_props.data.Status === "Verified" ? "pointer" : "not-allowed",
                }}>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 0, hide: 100 }}
                        overlay={
                            <Tooltip id="button-tooltip">
                                Export excel of verified K1
                            </Tooltip>
                        }
                        error={true}
                    >
                        <a href={
                            `${process.env.REACT_APP_BASE_URI}/workflow/k1/export/${k1FileId}/`
                        }
                            style={{
                                color: "var(--theme1_primary)",
                                pointerEvents: action_kone_props.data.Status === "Verified" ? "all" : "none"
                            }}
                            id={`export-${k1FileId}`}
                        >
                            <Icon.FileEarmarkExcel style={{ fontSize: 15, color: "var(--theme1_primary)" }} />
                        </a>
                    </OverlayTrigger>
                </div>
            </div>
        );
    };
    

    const ProgressKoneRenderer = (progress_kone_props) => {
        // console.log("PROGRESS KONE PROPS: ", progress_kone_props)
        return (
            <p>{progress_kone_props.data.ActiveKone.OCRProgress}</p>
        )
    }

    const PartnerNameRenderer = (partner_name_props) => {
        // console.log("PARTNER NAME KONE PROPS: ", partner_name_props)
        return (
            <p>{partner_name_props.data.ActiveKone.PartnerName}</p>
        )
    }

    const PartnershipNameRenderer = (partnership_name_props) => {
        // console.log("PARTNER NAME KONE PROPS: ", partner_name_props)
        return (
            <p>{partnership_name_props.data.ActiveKone.PartnerShipName}</p>
        )
    }

    const FileNameRenderer = (file_name_props) => {
        return (
            <OverlayTrigger
                placement="bottom"
                delay={{ show: 0, hide: 100 }}
                overlay={
                    <Tooltip id="button-tooltip">
                        Click to download pdf
                    </Tooltip>
                }
                error={true}
            >
                <a href={`${file_name_props.data.K1File}`}>{file_name_props.data.K1Name}</a>
            </OverlayTrigger>
        )
    }

    const FileYearRenderer = (file_year_props) => {
        // console.log("FILE YEAR PROPS: ", file_year_props)
        return (
            <p>{file_year_props.data.ActiveKone.FormYear}</p>
        )

    }

    // Declaring the api - grid connections
    const [columnDefs, setColumnDefs] = useState([
        {
            field: "PartnerName",
            headerName: "Partner name",
            cellRenderer: PartnerNameRenderer,
            checkboxSelection: true,
            headerCheckboxSelection: true,
            wrapText: true,   // Enable text wrapping
            autoHeight: true, // Adjust row height automatically
            // suppressMenu: true,
            width: 155
        },
        {
            field: "PartnershipName",
            headerName: "Partnership name",
            cellRenderer: PartnershipNameRenderer,
            wrapText: true,   // Enable text wrapping
            autoHeight: true, // Adjust row height automatically
            // checkboxSelection: true,
            // headerCheckboxSelection: true,
            // suppressMenu: true,
            minWidth: 100,
            width: 180
        },
        {
            field: "K1Name",
            headerName: "K1 name",
            cellRenderer: FileNameRenderer,
            // suppressMenu: true,
        },
        {
            field: "FormYear",
            headerName: "Year",
            cellRenderer: FileYearRenderer,
            width: 54
        },
        {
            field: "",
            headerName: "Progress",
            cellRenderer: ProgressKoneRenderer,
            width: 90
        },
        {
            field: "Status",
            headerName: "Status",
            width: 88,
            cellRenderer: CompareKoneRenderer,
        },
        {
            field: "CreatedDate",
            headerName: "Uploaded Date",
            width: 110,
            cellRenderer: (params) => CreatedDateRenderer(params.data.ActiveKone.CreatedDate)
        },
        {
            field: "UpdatedDate",
            headerName: "Updated Date",
            width: 115,
            cellRenderer: (params) => CreatedDateRenderer(params.data.ActiveKone.UpdatedDate)
        },
        {
            field: "",
            headerName: "Action",
            cellRenderer: ActionKoneRenderer,
            width: 100,
            suppressMenu: true
        }
    ]);


    const CustomNoRowsOverlay = (props) => {
        return (
            <div
                className="ag-overlay-loading-center flex-row-center-center"
                style={{ height: '9%' }}
            >
                <div className="spinner " style={{ fontSize: 14, fontWeight: 500 }}>
                    {props.noRowsMessageFunc()}
                </div>
            </div>
        );
    };

    const noRowsOverlayComponent = useMemo(() => {
        return CustomNoRowsOverlay;
    }, []);

    const noRowsOverlayComponentParams = useMemo(() => {
        return {
            noRowsMessageFunc: () => mykones_grid_props.gridMessage,
        };
    }, [mykones_grid_props.gridMessage]);

    return (
        <div className="integration-workflow">
            <div className="ag-theme-balham" style={gridStyle}>
                <AgGridReact
                    ref={gridRef}
                    rowData={mykones_grid_props.rowData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    onGridReady={mykones_grid_props.onGridReady}
                    alwaysShowHorizontalScroll={false}
                    alwaysShowVerticalScroll={false}
                    rowHeight={50}
                    suppressContextMenu={true}
                    onFirstDataRendered={onFirstDataRendered}
                    noRowsOverlayComponent={noRowsOverlayComponent}
                    noRowsOverlayComponentParams={noRowsOverlayComponentParams}
                    rowSelection={'multiple'}
                    onSelectionChanged={onSelectionChanged}
                // rowMultiSelectWithClick={true}
                />
            </div>
        </div>
    );
};
